module.exports = __webpack_public_path__ + "static/media/15-01.bcaf684b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/15-01.mp4
// module id = 118
// module chunks = 0